import { type ReactNode, useEffect } from 'react';
import { sessionRefresher, sessionStore } from '@/shared/api';
import { startSilentRenewal } from '../session-renewal';

/**
 * Provider de autenticação: mantém a sessão viva renovando o access token em silêncio antes de
 * expirar (e ao voltar para a aba). O estado da sessão fica no store em memória
 * (`useSession`); o token nunca vai para localStorage/sessionStorage.
 */
export function AuthProvider({ children }: { children: ReactNode }): ReactNode {
  useEffect(() => startSilentRenewal({ store: sessionStore, refresher: sessionRefresher }), []);
  return children;
}
